import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';
import React from 'react';

const CardHerramientas = ({ img, title, desc, url }) => {
  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardMedia component="img" alt={title} height="150" image={img} />
      <CardContent>
        <Typography
          gutterBottom
          variant="body1"
          fontWeight="bold"
          component="div"
        >
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {desc}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          onClick={() => {
            window.open(url, '_blank');
          }}
          size="small"
        >
          ABRIR
        </Button>
      </CardActions>
    </Card>
  );
};

export default CardHerramientas;
